export const parseDateField = (dataItem: unknown) => {
    return typeof dataItem === 'string' || typeof dataItem === 'number' || dataItem instanceof Date
        ? new Date(dataItem)
        : null;
};
